import React from 'react';
import AudioChristmas from '../../Components/audio/audio';
import BackGround from '../../Components/backstyle/backstyle';
import ChooseToys from '../../Components/choose-toys/choose-toys';
import ChooseTree from '../../Components/choose-tree/choose-tree';
import GarlandBtn from '../../Components/garland-btn/garland-btn';
import Garland from '../../Components/garland/garland';
import Snow from '../../Components/snow/snow';
import TreeCenter from '../../Components/tree-center/tree-center';
import TreeDecorate from '../../Components/tree-decorate/tree-decorate';
import { AppContext } from '../../Context/app-state';
import './Tree.css';

const Tree = () => {
  const { settings } = React.useContext(AppContext);
  const resetLocalStorage = () => {
    window.localStorage.clear();
    alert('Local Storage очищен! Пожалуйста, обновите страницу');
  };
  return (
    <div
      className="App-tree"
      style={{
        backgroundImage: `url(./assets/bg.jpg)`,
      }}
    >
      <div className="App-tree__blur">
        <div className="App-tree__container">
          <div className="App-tree__menu-left">
            <div className="App-tree__snow-audio left-container">
              <AudioChristmas />
              <Snow />
              <button
                className="App-tree__sort-reset"
                type="button"
                onClick={resetLocalStorage}
              >
                Сброс LocalStorage
              </button>
            </div>
            Выберите ёлку
            <ChooseTree />
            Выберите фон
            <BackGround />
            Выберите гирлянду
            <GarlandBtn />
          </div>
          <div
            id="fff"
            className="App-tree__center"
            style={{
              backgroundImage: `url(./assets/bg/${settings.background}.jpg)`,
            }}
          >
            <div
              className="snowflakes"
              style={{ display: settings.snow ? 'block' : 'none' }}
              aria-hidden="true"
            >
              <div className="snowflake">❅</div>
              <div className="snowflake">❅</div>
              <div className="snowflake">❆</div>
              <div className="snowflake">❄</div>
              <div className="snowflake">❅</div>
              <div className="snowflake">❆</div>
              <div className="snowflake">❄</div>
              <div className="snowflake">❅</div>
              <div className="snowflake">❆</div>
              <div className="snowflake">❄</div>
            </div>
            <Garland />
            <TreeCenter />
          </div>
          <div className="App-tree__menu-right">
            Игрушки
            <ChooseToys />
            <TreeDecorate />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tree;
